import script from "./Motolino-Settings-Users.vue?vue&type=script&setup=true&lang=js"
export * from "./Motolino-Settings-Users.vue?vue&type=script&setup=true&lang=js"

import "./Motolino-Settings-Users.vue?vue&type=style&index=0&id=77a008cb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77a008cb"]])

export default __exports__